import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { Sheet, Typography } from '@sunwebgroup/ui-components/uds'
import { getRoomExtraInfo } from '../selectors'
import { FieldSection, FieldSectionTitle, SheetContentStyled, SheetContentTitle, SheetHeaderStyled } from './SheetPortal'

export function RoomExtraInfoSheetPortal() {
  const roomExtraInfo = useGroupResponsibleStore(getRoomExtraInfo)
  const activeExtraInfoId = useGroupResponsibleStore(state => state.activeExtraInfoId)
  const changeExtraInfoId = useGroupResponsibleStore(state => state.changeExtraInfoId)
  const intl = useIntl()

  const isOpen = !!activeExtraInfoId

  function handleOpenChange(open: boolean) {
    if (!open) {
      changeExtraInfoId('')
    }
  }

  return (
    <Sheet.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Sheet.Body side="right" bottomSideInMobile={false}>
        <SheetHeaderStyled
          closeLabel={intl.formatMessage({ id: 'close' })}
          titleLabel={intl.formatMessage({ id: 'groups_responsible_room' })}
        />
        <SheetContentStyled>
          <SheetContentTitle as="div" $variant="display-g-regular">
            {roomExtraInfo.name}
          </SheetContentTitle>
          <FieldSection>
            <FieldSectionTitle $variant="body-s-regular-tight" as="div">
              {intl.formatMessage({ id: 'groups_responsible_hosts' })}
            </FieldSectionTitle>
            {roomExtraInfo.participants.length > 0
              ? (
                  roomExtraInfo.participants.map(participant => (
                    <Typography as="div" key={participant}>
                      {participant}
                    </Typography>
                  ))
                )
              : (
                  <Typography>-</Typography>
                )}
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-s-regular-tight" as="div">
              {intl.formatMessage({ id: 'groups_responsible_room_type' })}
            </FieldSectionTitle>
            <Typography>{roomExtraInfo.type}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-s-regular-tight" as="div">
              {intl.formatMessage({ id: 'groups_responsible_accommodation' })}
            </FieldSectionTitle>
            <Typography>{roomExtraInfo.accommodationName}</Typography>
          </FieldSection>
        </SheetContentStyled>
      </Sheet.Body>
    </Sheet.Root>
  )
}
